export enum BenefitType {
    OTHER = 'OTHER',
    EQUIPMENT = 'EQUIPMENT',
    TRANSPORT_AMENITIES = 'TRANSPORT_AMENITIES',
    SOUVENIRS = 'SOUVENIRS',
    FOOD_AND_DRINK = 'FOOD_AND_DRINK',
    FEES_AND_TAXES = 'FEES_AND_TAXES',
    UNKNOWN = 'UNKNOWN',
}
